import { FunctionalComponent, h } from '@stencil/core';
import { GeneralContentCategoryItems } from 'app/shared/services/general-content/models/general-content-category-items.model';

export interface CommonLinksProps {
  generalContentCategoryItems: GeneralContentCategoryItems[];
  productCategory: string;
  selectedPlanCategory: string;
  techType: string;
}

export const CommonLinks: FunctionalComponent<CommonLinksProps> = ({
  generalContentCategoryItems,
  productCategory,
  techType,
  selectedPlanCategory
}) => {
  let links = [];
  let searchCategory = '';
  if (productCategory === 'nbn') {
    if (techType === 'WIRELESS') {
      searchCategory = 'fixedWireless';
    } else if (selectedPlanCategory === 'Fibre upgrade') {
      searchCategory = 'fibreUpgrade';
    } else {
      searchCategory = 'nbn';
    }
  } else if (productCategory === 'mobile plan') {
    searchCategory = 'mobile';
  }
  [...generalContentCategoryItems.filter((x) => x.category === searchCategory)].forEach(
    (content) => (links = [...links, content.links[0]])
  );
  return (
    <ul class="common-links">
      {links.map((link) => (
        <li>
          <dls-link href={link.url} open-in-new-window>
            {link.title}
          </dls-link>
        </li>
      ))}
    </ul>
  );
};
